import { useContext } from "react";

const useAppState = useContext;
const useAppDispatch = useContext;

export { useAppState, useAppDispatch };
